<section>
  <ng-container *ngFor="let item of items | objectToArray">
    <ng-container *ngIf="item?.value?.length > 0">
      <h4 translate>{{'workflowbar.tooltip.header_files_' + item.key}}</h4>
      <ul>
        <li *ngFor="let fileObject of item.value">
          <span translate>{{ fileObject.filename}}</span>
          <span *ngIf="fileObject.created">{{fileObject.created | date:"dd MMM y HH:mm"}}</span>
        </li>
      </ul>
    </ng-container>
  </ng-container>
</section>
